import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { JugadorParaEmparejamiento } from "@/interfaces/Live";
import { TorneoGestionInfoMasDTO } from "@/interfaces/Torneo";
import { ref, watch, onMounted } from "vue";
import { getUsuariosNoInscritosTorneoAsync } from "@/services/UsuariosService";
import { UsuarioFastDTO } from "@/interfaces/Usuario";
import { CrearInscripcionDTO } from "@/interfaces/Inscripcion";
import { registrarInscripcion } from "@/services/InscripcionesService";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAddJugadorTorneoMas',
  props: {
    isVisible: { type: Boolean },
    torneo: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const internalIsVisible = ref(props.isVisible);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);

watch(
  () => props.isVisible,
  (newValue) => {
    internalIsVisible.value = newValue;
  }
);

const isGenerating = ref<boolean>(false);
const jugadorSelected = ref<JugadorParaEmparejamiento>();
const jugadores = ref<UsuarioFastDTO[]>();

const closeModal = () => {
  internalIsVisible.value = false;
  emit("close");
};

const addJugador = async () => {
  try {
    isGenerating.value = true;
    const idTorneo = props.torneo?.torneo.idTorneo;
    const idUsuario = jugadorSelected.value?.idUsuario;

    if (idTorneo === undefined || idUsuario === undefined) {
      throw new Error("El idTorneo o idUsuario no están definidos");
    }
    const addInscripcion: CrearInscripcionDTO = {
      idTorneo: idTorneo,
      idUsuario: idUsuario,
    };

    await registrarInscripcion(addInscripcion);
    showSuccessModal.value = true;

    const responseJugadores = await getUsuariosNoInscritosTorneoAsync(
      props.torneo.torneo.idTorneo
    );
    jugadores.value = (responseJugadores?.data ?? []).sort(
      (a: { nick: string }, b: { nick: string }) => a.nick.localeCompare(b.nick)
    );
    jugadorSelected.value = undefined;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
    emit("confirm");

    closeModal();
  }
};

onMounted(async () => {
  try {
    const responseJugadores = await getUsuariosNoInscritosTorneoAsync(
      props.torneo.torneo.idTorneo
    );
    jugadores.value = (responseJugadores?.data ?? []).sort(
      (a: { nick: string }, b: { nick: string }) => a.nick.localeCompare(b.nick)
    );
  } catch (error) {
    console.error("Error al obtener la información del torneo:", error);
    jugadores.value = [];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: internalIsVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((internalIsVisible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Agregar jugador manualmente")
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_combobox, {
                      modelValue: jugadorSelected.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((jugadorSelected).value = $event)),
                      items: jugadores.value,
                      "item-title": "nick",
                      "item-value": "idUsuario",
                      label: "Selecciona el jugador a añadir"
                    }, null, 8, ["modelValue", "items"]),
                    _createVNode(_component_v_row, {
                      justify: "center",
                      class: "my-4 ga-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "primary",
                          onClick: addJugador,
                          large: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Agregar jugador al torneo")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: closeModal,
                          large: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cancelar")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Jugador añadido correctamente.",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido añadir al jugador. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})